// PATH: src/utils/jwt.js
import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";
import axios from "./axios";

/**
 * Checks if the provided JWT token is valid (decodable + not expired).
 */
const isTokenValid = (authToken) => {
  if (typeof authToken !== "string" || authToken.trim() === "") {
    return false;
  }

  try {
    const decoded = jwtDecode(authToken);
    const currentTime = Date.now() / 1000; // seconds

    // token without a numeric exp is treated as invalid
    return typeof decoded.exp === "number" && decoded.exp > currentTime + 5;
  } catch (err) {
    console.error("Failed to decode token:", err);
    return false;
  }
};

/**
 * Returns expiry of the token as Date (or null if it can't be read).
 */
const getTokenExpiry = (authToken) => {
  try {
    const { exp } = jwtDecode(authToken);
    return typeof exp === "number" ? new Date(exp * 1000) : null;
  } catch {
    return null;
  }
};

/**
 * Sets or removes the authentication token in local storage and axios headers.
 */
const setSession = (authToken) => {
  if (typeof authToken === "string" && authToken.trim() !== "") {
    localStorage.setItem("authToken", authToken);
    axios.defaults.headers.common.Authorization = `Bearer ${authToken}`;
  } else {
    localStorage.removeItem("authToken");
    delete axios.defaults.headers.common.Authorization;
  }
};

// Cookie is the source of truth (localStorage copy can go stale).
const getAuthToken = () => Cookies.get("access_token") || null;

const isLoggedIn = () => {
  const token = getAuthToken();
  return token && isTokenValid(token) ? token : null;
};

export { isTokenValid, getTokenExpiry, setSession, isLoggedIn, getAuthToken };